import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable }                       from '@angular/core';
import { LoadingComponent }                 from './loading.component';

@Injectable({
    providedIn: 'root'
})

export class LoadingComponentService {

    private _loaders: { [key: string]: LoadingComponent } = {}

    private _fullScreenLoader: OverlayRef | null = null;

    constructor(
    ) { }


    get loaders() {
        return this._loaders;
    }
    
    public register(loader: LoadingComponent): void {
        this._loaders[loader.id] = loader;
    }

    public start(loaderid: string): void {
        this._loaders[loaderid].startLoader()
    }

    public stop(loaderid: string): void {
        this._loaders[loaderid].stopLoader();
    }

    public setMessage(loaderid: string, message: string) {
        this._loaders[loaderid].setMessage(message);
    }

    public setProgressMessage(loaderid: string, message: string) {
        this._loaders[loaderid].setProgressMessage(message);
    }

    public isLoading(loaderid: string): boolean {
        return this._loaders[loaderid].isLoading()
    }

    public loadingComplete(loaderid: string): void {
        return this._loaders[loaderid].completeLoader()
    }



}
